<template>
    <div>
        <b-modal id="modal-Add-Slots" class="modal-form" title="Add Slots Agent" @hidden="CLEAR_FORM()" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{formdata.name}}</div>
                    <div class="pt-1 pb-1"><strong>Email :</strong> {{formdata.email}}</div>

                </b-col>
                <b-col md="5">
                    <div class="pb-1"><strong>Total Events :</strong> {{formdata.events_count}} Event</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{formdata.slots}} Slot</div>
                </b-col>
                <b-col md="12" class="border-top border-bottom pb-3 pt-3 mt-3" v-if="formdata.distributor">
                        <div class="pt-1 pb-1"><strong>Distributor Name :</strong> {{formdata.distributor.name}}</div>
                        <div class="pt-1 pb-1"><strong>Distributor Email :</strong> {{formdata.distributor.email}}</div>
                </b-col>
            </b-row>

            <ValidationObserver ref="form">
                <validation-provider rules="required|min_value:1" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Slot</label>
                        <input v-model="slots" type="number" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                        <small>*Make sure you have enough slots, because they will be cut from your slots. Your Slot cannot Transfer Back to You from Agent, Make sure the value is right.</small>
                    </div>
                </validation-provider>

                <div class="button-modal text-right">
                    <button v-on:click="addSlotsAgent(formdata.id)" type="button" class="btn btn-new" v-bind:class="loading ? 'btn-progress' : ''">
                        Add Slots
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>

        <b-modal id="modal-Event-Agent" size="xl" class="modal-form" title="Agent Information" @hidden="CLEAR_DATA_EVENTS_AGENTS(), del_events = []" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="6">
                    <div class="pb-1"><strong>Agent Name :</strong> {{events_agent.name}}</div>
                    <div class="pt-1"><strong>Email :</strong> {{events_agent.email}}</div>
                </b-col>
                <b-col md="6">
                    <div class="pb-1"><strong>Total Agents :</strong> {{events_agent.events.length}} Event</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{events_agent.slots}} Slots</div>
                </b-col>
            </b-row>

            <h6 class="border-top pt-4 mb-3">List Event</h6>

            <div class="table-responsive bdr-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="all_id" v-model="selectAll">
                                    <label class="custom-control-label" for="all_id"></label>
                                </div>
                            </th>
                            <th>Action</th>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Date Event</th>
                            <th>Theme</th>
                            <th>Package</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr-ac" v-for="data in events_agent.events" :key="data.id" @click.prevent="detailEvents(data)">
                            <td width="100px" v-on:click.stop="">
                                <div class="custom-control custom-checkbox" v-if="data.id !== 1">
                                    <input type="checkbox" class="custom-control-input" v-model="del_events" :value="data.id" :id="data.id">
                                    <label class="custom-control-label" :for="data.id"></label>
                                </div>
                            </td>
                            <td v-on:click.stop="">
                                <b-dropdown id="dropdown-left" text="Settings" variant="primary" class="mt-2 mb-2">
                                    <template #button-content>
                                        Settings <i class="uil uil-angle-down"></i>
                                    </template>

                                    <b-dropdown-item href="#" v-if="data.status === 0" @click.prevent="detailEvents(data)">Edit Event</b-dropdown-item>
                                    <b-dropdown-item href="#" v-if="data.status === 0" @click.prevent="alertStatusEvents(data)">Publish Event</b-dropdown-item>
                                    <b-dropdown-item href="#" v-if="data.status === 1" @click.prevent="alertStatusEvents(data)">Un-Publish Event</b-dropdown-item>
                                    <b-dropdown-item target="_blank" :href="data | eventLink">Visit Event</b-dropdown-item>
                                    <b-dropdown-divider></b-dropdown-divider>
                                    <b-dropdown-item href="#" @click.stop.prevent="copyBioLink(data.id)"><i class="uil uil-copy"></i> Copy Event Link</b-dropdown-item>
                                    <b-dropdown-item v-if="data.type === 'PREMIUM'" href="#" @click.stop.prevent="copyAnalyticsLink(data.id)"><i class="uil uil-copy"></i> Copy Event Analytics Link</b-dropdown-item>
                                </b-dropdown>

                                <input type="hidden" :id="'biolink' + data.id" :value="$options.filters.eventLink(data)">
                                <input type="hidden" :id="'analyticslink' + data.id" :value="$options.filters.analyticsLink(data)">
                            </td>
                            <td>{{data.id}}</td>
                            <td>{{data.title}}</td>
                            <td>{{data.category ? data.category : '-'}}</td>
                            <td>{{data.date_event | formatDate}}</td>
                            <td>{{data.theme ? data.theme.name : '-'}}</td>
                            <td>
                                <div class="premium-label" v-if="data.type === 'PREMIUM'">{{data.type}}</div>
                                <div class="standard-label" v-if="data.type === 'STANDARD'">{{data.type}}</div>
                            </td>
                            <td width="100px">
                                <label v-if="data.status === 1" class="badge badge-success"><i class="uil uil-check"></i> Publish</label>
                                <label v-if="data.status === 0" class="badge badge-info"><i class="uil uil-hourglass"></i> On Progress</label>
                            </td>
                        </tr>

                    </tbody>

                </table>
                <p v-if="events_agent.events.length === 0" class="text-center no-data">Events data not found</p>

                <button type="button" v-if="del_events.length !== 0" v-on:click.prevent="alertDeleteEvents()" class="btn btn-danger mt-4 mb-2 bdr-15 border-0">
                    <i class="uil uil-times"></i> Delete
                </button>
            </div>
        </b-modal>

        <b-modal id="modal-Challenge" size="lg" class="modal-form" @hidden="CLEAR_FORM()" title="Challenge User" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{formdata.name}}</div>
                    <div class="pt-1 pb-1"><strong>Email :</strong> {{formdata.email}}</div>
                </b-col>
            </b-row>
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Challenge Name</th>
                            <th>Achievement</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr-ac" v-for="(data) in formdata.challenge" :key="data.id">
                            <td>
                                <div>{{data.challenge.name}}</div>
                                <small>{{data.challenge.start_date | formatDate}} - {{data.challenge.end_date | formatDate}}</small>
                            </td>
                            <td>{{data.achievement ? data.achievement.name : '-'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver} from "vee-validate";
    import moment from 'moment'

    export default{
        data(){
            return{
                loading:false,
                slots:null,
                del_events:[]
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
            eventLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug
            },
            analyticsLink: function(value) {
                var frameURL;
                if(process.env.NODE_ENV == 'development'){
                    frameURL = 'http://localhost:3000/'
                }else if(process.env.NODE_ENV == 'production'){
                    frameURL = window.location.origin.replace('app.','') + '/'
                }
                return frameURL + value.id + '/' + value.slug + '/analytics?code=' + value.token_analytics
            },
        },
        computed: {
            ...mapState('AgentsControl', {
                formdata: state => state.formdata,
                events_agent: state => state.events_agent
            }),

            selectAll: {
                get: function () {
                    return this.events_agent.events ? this.del_events.length == this.events_agent.events.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.events_agent.events.forEach(function (events) {
                            if(events.id !== 1){
                                selected.push(events.id);
                            }
                        });
                    }
                    this.del_events = selected;
                }
            }
        },
        methods: {
            ...mapActions('AgentsControl', ['updateSlotsAgents']),
            ...mapActions('EventsControl', ['deleteEvents','changeStatusEvent']),
            ...mapMutations('AgentsControl', ['CLEAR_FORM','CLEAR_DATA_EVENTS_AGENTS']),

            copyBioLink (id) {
                let bioLinkToCopy = document.querySelector('#biolink' + id)
                bioLinkToCopy.setAttribute('type', 'text')
                bioLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                bioLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            copyAnalyticsLink(id) {
                let AnalyticsLinkToCopy = document.querySelector('#analyticslink' + id)
                AnalyticsLinkToCopy.setAttribute('type', 'text')
                AnalyticsLinkToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'Berhasil' : 'Gagal';
                    this.$toast.success( msg + ' Disalin')
                } catch (err) {
                    this.$toast.warning( 'Maaf, text tidak bisa disalin')
                }

                AnalyticsLinkToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            detailEvents:function(data){
                if(data.status === 1){
                    this.$toast.warning('You cannot edit this event because it is already published')
                }else if(data.status === 0){
                    this.$router.push({ name: 'details-event', params: { id:data.id,slug:data.slug } })
                }
            },
            alertStatusEvents:function(data){
                var text = '';
                var sts = null;

                if(data.status === 0){
                    text = 'Are you sure you publish event ' + data.title + ' ?'
                    sts = 1
                }else if(data.status === 1){
                    text = 'Are you sure you un-publish event ' + data.title + ' ?'
                    sts = 0
                }

                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.changeStatusEvent({id:data.id,status:sts}).then(
                            this.$emit('getAgentsModal'),
                            this.$toast.success('Successfully Change Status Event'),
                        )
                    }
                })
            },
            alertDeleteEvents:function(){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this event data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deleteEvents(this.del_events).then(
                            this.$emit('getAgentsModal'),
                            this.$toast.success('Successfully Deleting Events'),
                            this.del_events = []
                        )
                    }
                })
            },
            addSlotsAgent: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var form = {
                            slots: this.slots,
                            id: id
                        }

                        this.updateSlotsAgents(form).then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Add-Slots')
                            this.$emit('getAgents');
                            this.slots = null
                            this.$toast.success('Successfully Updated Slots')
                        })
                    }
                });
            }
        }
    }
</script>
